import { a as SET_PAGE_NAME_VAR, P as PageName } from './index2.js';

/**
 * **Bookolo**
 *
 * @exports bs_350
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_350
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.querySelector('html');
        if (container && !thn.bookoloRefresh) {
            const bookoloChange = thn.debounce(function () {
                if (document.querySelector('.lib--dialog')) {
                    window[SET_PAGE_NAME_VAR] = 'Extras';
                    thn.pageCheck();
                    return;
                }
                if (!document.querySelector('.lib--dialog') && !document.querySelector('.comp_base_purchase')
                    && window.location.pathname.match(/(v3\/book)/) && !window.location.pathname.match(/purchase\/complete/)) {
                    window[SET_PAGE_NAME_VAR] = PageName.RoomsAndRates;
                    thn.pageCheck();
                    return;
                }
                thn.pageCheck();
            }, 1000);
            thn.bookoloRefresh = function bookoloObserver(mutations) {
                const validMutationsModal = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target && mutation.target.className.match(/mod--loaded/)).filter((mapResult) => !thn.empty(mapResult)); // mutation to detect Extras and User Register Page
                const validMutationsIndex = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target && mutation.target.className.match(/datepickers-container/)).filter((mapResult) => !thn.empty(mapResult)); // mutation to detect return to Index Page
                if (validMutationsModal.length || validMutationsIndex.length) {
                    bookoloChange();
                }
            };
            thn.observeDom(container, thn.bookoloRefresh, {
                childList: true,
                subtree: true,
                characterData: false,
                attributes: true,
            });
            thn.shutdown(function () {
                bookoloChange.cancel();
                thn.stopObserveDom(container, thn.bookoloRefresh);
                delete thn.bookoloRefresh;
            });
        }
    };
    /**
       * @memberOf module:bs_350
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        const langDictionary = {
            Česky: 'cs',
            English: 'en',
            Deutsch: 'de',
        };
        const langDictionaryV2 = {
            ua: 'uk',
            jp: 'ja',
        };
        return new Promise(function (resolve, reject) {
            const langElement = document.querySelector('.langs[title]')?.getAttribute('title');
            const htmlLang = document.documentElement.lang;
            const lang = (window.dataLayer && thn.objectGet(window.dataLayer, 'languageCode', { first: false }))
                || langDictionary[langElement]
                || htmlLang;
            const finalLang = langDictionaryV2[lang] || lang;
            if (finalLang && ctx.langs.test(finalLang)) {
                resolve(finalLang);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_350
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
     * @memberOf module:bs_350
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        ctx.promocode = document.querySelector('#frm-promoForm-promoForm-promo')?.value;
        return ctx.promocode;
    };
    /**
     * @memberOf module:bs_350
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://www.hotel-imperial.cz/en/booking/?date_in=2023-12-05&date_out=2023-12-06&promo_code=
        const url = new URL(ctx.baseUrl);
        const validUrl = !!url.pathname.match(/booking|rezervace|reservieren|prenotare|reservar/) && !url.hostname.match(/bookoloengine/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        const langDictionary = {
            cs: 'cz',
            ja: 'jp',
        };
        const pathDictionary = {
            it: 'prenotare',
            cz: 'rezervace',
            de: 'reservieren',
            es: 'reservar',
        };
        url.searchParams.delete('date_in');
        url.searchParams.delete('date_out');
        url.searchParams.delete('promo_code');
        ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
        ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
        url.pathname = `${langDictionary[ctx.data.language] || '[language]'}/${pathDictionary[langDictionary[ctx.data.language] || ctx.data.language] || 'booking'}/`;
        url.searchParams.set('datein', ctx.newData.dateBegin);
        url.searchParams.set('dateout', ctx.newData.dateEnd);
        url.searchParams.set('adults', '[adults]');
        url.searchParams.set('children', '[children]');
        const childrenAges = ctx.data?.roomsDispo?.[0]?.childrenAges;
        if (ctx.data.children > 0 && childrenAges) {
            const stringArray = JSON.stringify(childrenAges);
            url.searchParams.set('childrenAges', stringArray);
        }
        ctx.newUrl = url.toString();
        return ctx;
    };
    return engine;
}

export { factory };
